import React from 'react'
import DateFormat from '../../../shared/helpers/date-format'
import { fourDConstants } from '../../../constants/string-constants'

let { timeSimple, timeMeridian } = DateFormat

const LEARN_MORE_LINK = '/experiences/4-d-experiences'

const FourDExperiences = ({ films }) => {
  if (!films || Object.keys(films).length === 0) {
    return null
  }
  else {
    return (
      <div className="text-16 lg:text-18">
        <div className="container mb-24 md:mb-60 md:text-center">
          <h2>{fourDConstants.fourDTitle}</h2>
          <p>
             {fourDConstants.fourDDescription}{' '}
            <a
              href={LEARN_MORE_LINK}
            >
              {fourDConstants.fourDLearnMore}
            </a>
          </p>
        </div>
        <div className="container max-w-lg mb-24 md:mb-60">
          <ul className="md:flex justify-center text-center">
            {Object.keys(films).map(title => (
              <li
                key={title}
                className="md:w-1/2 lg:w-1/3 md:px-12 mb-32 md:mb-0"
              >
                <FourDExperience
                  title={title}
                  shows={films[title]}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

const FourDExperience = ({ title, shows }) => {
  const medium = shows[0].thumbnailPhoto.medium

  return (
    <React.Fragment>
      <a
        className="no-underline"
        href={LEARN_MORE_LINK}
      >
        <img
          className="w-full"
          src={medium}
          alt=""
        />
        <h3>{title}</h3>
      </a>
      <ul className="flex flex-wrap md:w-5/6 mx-auto leading-loose">
        {shows.map(show => (
          <li
            key={show.time}
            className="w-1/3 text-depths text-12 px-8"
          >
            {timeSimple(show.time)}{' '}
            <span className="lowercase">{timeMeridian(show.time)}</span>
          </li>
        ))}
      </ul>
    </React.Fragment>
  )
}

export default FourDExperiences
